/* @flow */
import {reduce} from 'lodash';

const prefixKey =
  (prefix?: string, key: string): string =>
    prefix ? `${prefix}.${key}` : key;

const flattenMessages = (
  nestedMessages: Object,
  prefix?: string
): Object => reduce(
  nestedMessages,
  (flattenedMessages: Object, value: string|Object, key: string): Object =>
    Object.assign(
      flattenedMessages,
      typeof value === 'string'
        ? { [prefixKey(prefix, key)]: value }
        : flattenMessages(value, prefixKey(prefix, key))
    ),
  {}
);

export default flattenMessages;
